import {
  LegalLinkLine,
  LegalPageFrame,
  LegalParagraph,
  LegalSectionView,
} from '@/components/legal/legal-document';
import { PaymentsPrivacySection } from '@/components/legal/payments-terms-section';
import { SeoHead, SITE_URL } from '@/components/seo-head';
import {
  LEGAL_DISCLAIMER,
  PRIVACY_DESCRIPTION,
  PRIVACY_PATH,
  PRIVACY_SECTIONS,
  PRIVACY_TITLE,
  PRIVACY_VERSION,
  PRIVACY_VERSION_LABEL,
} from '@/content/legal/privacy';
import { pageTitle } from '@/lib/seo/meta';
import React from 'react';
import { View } from 'react-native';

/**
 * Política de privacidade (`/privacidade`): página própria, estática e sem
 * abas, para o texto inteiro sair no HTML (é o endereço das lojas e do aviso
 * de cookies). O texto fica em `content/legal/privacy.ts`.
 */
export default function PrivacyScreen() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${SITE_URL}${PRIVACY_PATH}#page`,
      url: `${SITE_URL}${PRIVACY_PATH}`,
      name: PRIVACY_TITLE,
      description: PRIVACY_DESCRIPTION,
      inLanguage: 'pt-BR',
      dateModified: PRIVACY_VERSION,
      isPartOf: { '@id': `${SITE_URL}/#website` },
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
  ];

  return (
    <LegalPageFrame
      screenTitle="Privacidade"
      head={
        <SeoHead
          title={pageTitle(PRIVACY_TITLE)}
          description={PRIVACY_DESCRIPTION}
          path={PRIVACY_PATH}
          jsonLd={jsonLd}
        />
      }
      title={PRIVACY_TITLE}
      meta={`Versão de ${PRIVACY_VERSION_LABEL}`}
      footerLinks={[
        { label: 'Termos de uso', href: '/terms' },
        { label: 'Fale com a gente', href: '/contato' },
      ]}
    >
      {PRIVACY_SECTIONS.map((section) => (
        <LegalSectionView key={section.id} section={section} />
      ))}
      <PaymentsPrivacySection sectionNumber={PRIVACY_SECTIONS.length + 1} />
      <View className="gap-2">
        <LegalParagraph>{LEGAL_DISCLAIMER}</LegalParagraph>
        <LegalLinkLine link={{ label: 'Excluir sua conta', url: '/excluir-conta' }} />
      </View>
    </LegalPageFrame>
  );
}
